<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>批量激活</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom">
		<div v-for="(item,index) in data" class="z-subAccount-item" @click="onSelectAccount(item.uid)">
			<div class="z-subAccount-user">
				<img :src="item.avatar" class="z-user-avatar">
				<div class="z-subAccount-info">
					<div v-text="item.name"></div>
					<div v-text="'交易号：'+(item.trade_account ? item.trade_account : '待入金')"></div>
				</div>
			</div>
			<div class="z-subAccount-state" v-show="selectAccount.indexOf(item.uid) !== -1">
				<img src="../../assets/index/sub-account/yes.png" class="z-icon">
			</div>
		</div>
	</div>
	<div class="z-gather-box">
		<div class="z-btn-long z-gather-btn" @click="onPost">一键激活（{{selectAccount.length}}个）</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'batchActiveAccount',
	data() {
		return {
			data:[],
			selectAccount:[]
		}
	},
	created() {
		this.getData()
	},
	methods: {
		onSelectAccount(uid){
			let idx = this.selectAccount.indexOf(uid)
			if ( idx === -1) {
				this.selectAccount.push(uid)
			}
			else {
				this.selectAccount.splice(idx,1)
			}

		},
		getData(){
			this.get('api/users/childs',{income:0}).then((rs)=>{
				this.data = rs.data
			})
		},
		onPost(){
			if (this.selectAccount.length==0) {
				this.$store.commit('layer','请点击列表勾选')
				return false
			}
			this.post('api/users/multiIncome',{ids:this.selectAccount.join(',')}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.getData()
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	border-bottom: 1px solid #27292F;
}
.z-subAccount-user {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-subAccount-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}

.z-icon {
	width: 18px;
	height: 18px;
}
.z-gather-box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #20232A;
	border-top: 2px solid #1E1F22;
}
.z-gather-btn{
	border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/batchActiveAccount.vue